import { supabase } from "../../../services/storageClient";

export default async function UploadImage({ nreg, images }) {
    console.log('Received Data: ', nreg, 'Images: ', images)
    
    const startUpload = async (path, image) => {
        try {
            const { data, error } = await supabase.storage
                .from('imv_images')
                .upload(path, image)

            if (error) {
                console.error('Deu Ruim: ', error)
            } else {
                window.alert('Imagens Enviadas!')
                console.log('Imagens Enviadas!')
            }

        } catch (e) {
            console.error('Erro ao iniciar Upload: ', e)
        }
    }

    if (images && images.length > 0) {
        for (let i = 0; i < images.length; i++) {
            const image = images[i]
            const imagePath = `${nreg}/${image.name}`
            try {
                await startUpload(imagePath, image)
            } catch (e) {
                console.error('Nao foi possivel Enviar as Imagens: ', e)
            }
        }
    } else {
        return console.error('Imagens Nao foram Encontradas')
    }
}